import Backbone from "pages/common/lib/backbone-helpers";
import _ from "underscore";
import { onSnapshot } from "mobx-state-tree";
import CONSTANTS from "const/constants";
import ConnectModelToStore from "./connectModelToStore";

const { BACKBONE_EVENTS } = CONSTANTS;

const ConnectCollectionToStore = ({
    collection,
    store,
    _model,
    polymorphicModel
}) => {
    const Collection = collection.extend({
        initialize: function () {
            Collection.__super__.initialize.apply(this, arguments);
            this.store = store;
            this.store.__setBackboneCollection(this);
            this.on(
                BACKBONE_EVENTS.UPDATE,
                (_collection, options) => {
                    if (!options.preventStoreUpdate) {
                        store?.__syncRead();
                    }
                },
                this
            );

            if (!_.isUndefined(store)) {
                onSnapshot(store, () => {
                    this.set(store.__getModels(), { preventStoreUpdate: true });
                });
            }
        },

        model: _model
            ? ConnectModelToStore(_model, store, true)
            : (attrs, options) => {
                  const model = polymorphicModel(attrs);
                  return new (ConnectModelToStore(model, store, true))(
                      attrs,
                      options
                  );
              },

        url: function () {
            return ``;
        },

        parse: function (res) {
            return res;
        },

        /**
         * @summary Override default CRUD methods with mobX store methods
         * For more detailed docs on sync, see - https://backbonejs.org/#Sync
         * @param {String("create" | "read" | "update" | "delete")} method – the CRUD method
         * @param {Object} _collection – collection to be read
         * @param {Object} options – success and error callbacks, and all other jQuery request options
         * @return {String} method
         */
        sync: async function (method, _collection, options) {
            const { error, success } = options;
            switch (method) {
                case `create`:
                    console.warn(
                        `Migrated collection is attempting to sync a CREATE method`
                    );
                    break;
                case `read`:
                    try {
                        const response = await store.__syncRead();
                        success && success(response);
                    } catch (err) {
                        error && error(err);
                    }
                    break;
                case `update`:
                    console.warn(
                        `Migrated collection is attempting to sync an UPDATE method`
                    );
                    break;
                case `delete`:
                    console.warn(
                        `Migrated collection is attempting to sync a DELETE method`
                    );
                    break;
                default:
                    return Backbone.sync.apply(this, arguments);
            }
        },

        /**
         * @summary Reset the associated store then update
         * the entire collection with the returned list of models
         * @param {Array} models
         * @param {Object} options
         * @return {Array} Rerturns list of new models
         */
        reset: function (models, options) {
            options = options ? _.clone(options) : {};
            // Sever models ties to the collection
            for (let i = 0; i < this.models.length; i++) {
                this._removeReference(this.models[i], options);
            }
            options.previousModels = this.models;
            // Reset all internal state
            this._reset();
            const storeData = store.__reset(models);
            models = this.add(
                storeData,
                _.extend(
                    {
                        silent: true,
                        preventStoreUpdate: true
                    },
                    options
                )
            );
            if (!options.silent) this.trigger(`reset`, this, options);
            return models;
        },

        sort: function (options) {
            collection.prototype.sort.call(this, options);
            store.__sort();
        },

        comparator: function () {
            return undefined;
        }
    });
    return Collection;
};

export default ConnectCollectionToStore;
